import { render } from "./AWall.vue?vue&type=template&id=65eee06f&scoped=true"
import script from "./AWall.vue?vue&type=script&lang=js"
export * from "./AWall.vue?vue&type=script&lang=js"

import "./AWall.vue?vue&type=style&index=0&id=65eee06f&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65eee06f"]])

export default __exports__